var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [
    [_c('h3', [_vm._v("Tree")]), _vm._v(" "), _c('div', {
      staticClass: "bs-docs-section"
    }, [_c('blockquote', [_c('p', [_vm._v("Tree (base)")])]), _vm._v(" "), _c('div', {
      staticClass: "bs-example"
    }, [_c('n3-tree', {
      attrs: {
        "data": _vm.data,
        "props": _vm.defaultProps
      },
      on: {
        "node-click": _vm.handleNodeClick
      }
    })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("Tree (checked, selected)")])]), _vm._v(" "), _c('div', {
      staticClass: "bs-example"
    }, [_c('n3-tree', {
      attrs: {
        "data": _vm.regions,
        "props": _vm.props,
        "load": _vm.loadNode,
        "lazy": "",
        "show-checkbox": ""
      },
      on: {
        "check-change": _vm.handleCheckChange
      }
    })], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h3', [_vm._v("Params")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h3', [_vm._v("props")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h3', [_vm._v("Methods")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h3', [_vm._v("Events")]), _vm._v(" "), _vm._m(7)], 1)]
  ], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": "",
      "class": "language-html"
    }
  }, [_c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-tree")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":data")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"data\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":props")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"defaultProps\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("@node-click")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"handleNodeClick\"")]), _vm._v(">")]), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-tree")]), _vm._v(">")]), _vm._v("\n")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": "",
      "class": "language-javascript"
    }
  }, [_c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("default")]), _vm._v(" {\n  data() {\n    "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("return")]), _vm._v(" {\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("data")]), _vm._v(": [{\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'folder1'")]), _vm._v(",\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("children")]), _vm._v(": [{\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'file1'")]), _vm._v("\n        }]\n      }, {\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'folder2'")]), _vm._v(",\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("children")]), _vm._v(": [{\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'file2'")]), _vm._v("\n        }, {\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'file3'")]), _vm._v("\n        }]\n      }, {\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'folder3'")]), _vm._v(",\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("children")]), _vm._v(": [{\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'folder4'")]), _vm._v(",\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("children")]), _vm._v(": [{\n            "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'file6'")]), _vm._v("\n          }]\n        }, {\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'file4'")]), _vm._v("\n        }, {\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'file5'")]), _vm._v("\n        }]\n      }],\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("defaultProps")]), _vm._v(": {\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("children")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'children'")]), _vm._v(",\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'label'")]), _vm._v("\n      }\n    }\n  },\n  "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("methods")]), _vm._v(": {\n    handleNodeClick(data) {\n      "), _c('span', {
    attrs: {
      "class": "hljs-built_in"
    }
  }, [_vm._v("console")]), _vm._v(".log(data)\n    }\n  }\n}\n")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": "",
      "class": "language-html"
    }
  }, [_c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-tree")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":data")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"regions\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":props")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"props\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":load")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"loadNode\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("lazy")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("show-checkbox")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("@check-change")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"handleCheckChange\"")]), _vm._v(">")]), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-tree")]), _vm._v(">")]), _vm._v("\n")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": "",
      "class": "language-javascript"
    }
  }, [_c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("default")]), _vm._v(" {\n    data() {\n      "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("return")]), _vm._v(" {\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("defaultProps")]), _vm._v(": {\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("children")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'children'")]), _vm._v(",\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'label'")]), _vm._v("\n        },\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("regions")]), _vm._v(": [{\n          "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'name'")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'/root'")]), _vm._v("\n        }, {\n          "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'name'")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'/home'")]), _vm._v("\n        }],\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("props")]), _vm._v(": {\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'name'")]), _vm._v(",\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("children")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'zones'")]), _vm._v("\n        },\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("count")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-number"
    }
  }, [_vm._v("1")]), _vm._v("\n      }\n    },\n    "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("methods")]), _vm._v(": {\n      handleCheckChange(data, checked, indeterminate) {\n        "), _c('span', {
    attrs: {
      "class": "hljs-built_in"
    }
  }, [_vm._v("console")]), _vm._v(".log(data, checked, indeterminate)\n      },\n      loadNode(node, resolve) {\n        "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("if")]), _vm._v(" (node.level === "), _c('span', {
    attrs: {
      "class": "hljs-number"
    }
  }, [_vm._v("0")]), _vm._v(") {\n          "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("return")]), _vm._v(" resolve([{ "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'/root'")]), _vm._v(" }, { "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'/home'")]), _vm._v(" }])\n        }\n        "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("if")]), _vm._v(" (node.level > "), _c('span', {
    attrs: {
      "class": "hljs-number"
    }
  }, [_vm._v("3")]), _vm._v(") "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("return")]), _vm._v(" resolve([])\n\n        "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("var")]), _vm._v(" hasChild\n        "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("if")]), _vm._v(" (node.data.name === "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'/root'")]), _vm._v(") {\n          hasChild = "), _c('span', {
    attrs: {
      "class": "hljs-literal"
    }
  }, [_vm._v("true")]), _vm._v("\n        } "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("else")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("if")]), _vm._v(" (node.data.name === "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'/home'")]), _vm._v(") {\n          hasChild = "), _c('span', {
    attrs: {
      "class": "hljs-literal"
    }
  }, [_vm._v("false")]), _vm._v("\n        } "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("else")]), _vm._v(" {\n          hasChild = "), _c('span', {
    attrs: {
      "class": "hljs-built_in"
    }
  }, [_vm._v("Math")]), _vm._v(".random() > "), _c('span', {
    attrs: {
      "class": "hljs-number"
    }
  }, [_vm._v("0.5")]), _vm._v("\n        }\n\n        setTimeout("), _c('span', {
    attrs: {
      "class": "hljs-function"
    }
  }, [_c('span', {
    attrs: {
      "class": "hljs-params"
    }
  }, [_vm._v("()")]), _vm._v(" =>")]), _vm._v(" {\n          "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("var")]), _vm._v(" data\n          "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("if")]), _vm._v(" (hasChild) {\n            data = [{\n              "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'新建文件夹'")]), _vm._v(" + "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("this")]), _vm._v(".count++\n            }, {\n              "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'新建文件夹'")]), _vm._v(" + "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("this")]), _vm._v(".count++\n            }]\n          } "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("else")]), _vm._v(" {\n            data = []\n          }\n\n          resolve(data)\n        }, "), _c('span', {
    attrs: {
      "class": "hljs-number"
    }
  }, [_vm._v("500")]), _vm._v(")\n      }\n    }\n  }\n")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("data")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("[]")])]), _vm._v(" "), _c('td', [_vm._v("data")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("empty-text")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("Empty Content.")]), _vm._v(" "), _c('td', [_vm._v("Show text when the data is empty")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("node-key")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("Each tree node is used as a unique attribute, and the whole tree should be unique")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("props")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("leaf-icon")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("file")]), _vm._v(" "), _c('td', [_vm._v("leaf icon")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("child-icon")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("folder")]), _vm._v(" "), _c('td', [_vm._v("child icon")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("closed-icon")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("angle-right")]), _vm._v(" "), _c('td', [_vm._v("closed icon")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("opened-icon")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("angle-down")]), _vm._v(" "), _c('td', [_vm._v("open icon")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("load")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td', [_vm._v("function(node, resolve) {}")]), _vm._v(" "), _c('td', [_vm._v("Methods for loading subtree data")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("render-content")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td', [_vm._v("function(h, { node }) {}")]), _vm._v(" "), _c('td', [_vm._v("render function")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("highlight-current")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("false")])]), _vm._v(" "), _c('td', [_vm._v("Whether to highlight the currently selected node")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("current-node-key")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String, Number")])]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("Currently select the node's key, write only attribute")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("default-expand-all")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("false")])]), _vm._v(" "), _c('td', [_vm._v("Whether to expand all nodes by default")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("expand-on-click-node")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("true")])]), _vm._v(" "), _c('td', [_vm._v("Whether to expand or shrink the node when the node is clicked (if it is only then the arrow icon will only start or shrink the node.)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("auto-expand-parent")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("true")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("default-expanded-keys")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("The array of the default expanded node's key")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("show-checkbox")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("false")])]), _vm._v(" "), _c('td', [_vm._v("Whether the node can be checked")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("check-strictly")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("false")])]), _vm._v(" "), _c('td', [_vm._v("In the case of the check box, whether to strictly follow the father and son are not associated with each other")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("default-checked-keys")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("[]")])]), _vm._v(" "), _c('td', [_vm._v("The default check of the node's key array")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("filter-node-method")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td', [_vm._v("function(value, data, node)")]), _vm._v(" "), _c('td', [_vm._v("The method that is executed when the tree node is filtered, true returns that the node can be displayed and vice versa")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("label")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("label")]), _vm._v(" "), _c('td', [_vm._v("Specifies that the node tag is a property value for the node object")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("children")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("children")]), _vm._v(" "), _c('td', [_vm._v("Specifies that the subtree is a property value for the node object")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("params")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("filter")]), _vm._v(" "), _c('td', [_vm._v("Filter the tree nodes")]), _vm._v(" "), _c('td', [_vm._v("Receive an arbitrary type of parameter, this parameter will be in the filter-node-method as the first parameter")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("getCheckedNodes")]), _vm._v(" "), _c('td', [_vm._v("If the node can be selected (ie "), _c('code', {
    pre: true
  }, [_vm._v("show-checkbox")]), _vm._v(" is"), _c('code', {
    pre: true
  }, [_vm._v("true")]), _vm._v("), the array of the currently selected nodes is returned")]), _vm._v(" "), _c('td', [_vm._v("LeafOnly) to receive a boolean type of parameters, if the "), _c('code', {
    pre: true
  }, [_vm._v("true")]), _vm._v(" only return to the selected leaf node, the default value is"), _c('code', {
    pre: true
  }, [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("setCheckedNodes")]), _vm._v(" "), _c('td', [_vm._v("Set the currently checked node, use this method must set the node-key attribute")]), _vm._v(" "), _c('td', [_vm._v("(Nodes) Receive an array of checked node data")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("getCheckedKeys")]), _vm._v(" "), _c('td', [_vm._v("If the node can be selected (ie "), _c('code', {
    pre: true
  }, [_vm._v("show-checkbox")]), _vm._v(" is"), _c('code', {
    pre: true
  }, [_vm._v("true")]), _vm._v("), the array of the currently selected nodes is returned")]), _vm._v(" "), _c('td', [_vm._v("(LeafOnly) to receive a boolean type of parameters, if the "), _c('code', {
    pre: true
  }, [_vm._v("true")]), _vm._v(" only return the selected leaves node keys, the default value is"), _c('code', {
    pre: true
  }, [_vm._v("true")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("setCheckedKeys")]), _vm._v(" "), _c('td', [_vm._v("Use the keys to set the currently checked node, and use this method to set the node-key attribute")]), _vm._v(" "), _c('td', [_vm._v("(Keys, leafOnly) to receive two parameters, 1. check the node's key array 2. boolean type of parameters, if the "), _c('code', {
    pre: true
  }, [_vm._v("true")]), _vm._v(" only set the leaves node selected state, the default value is"), _c('code', {
    pre: true
  }, [_vm._v("true")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("setChecked")]), _vm._v(" "), _c('td', [_vm._v("Through the key / data set a node check the state, use this method must set the node-key attribute")]), _vm._v(" "), _c('td', [_vm._v("(key/data, checked, deep)Receive three parameters, 1. check the node's key or data 2. boolean type, the node is selected 3. boolean type, whether to set the child node, the default is false")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("params")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("node-click")]), _vm._v(" "), _c('td', [_vm._v("The callback when the node is clicked")]), _vm._v(" "), _c('td', [_vm._v("A total of three parameters, as follows: "), _c('code', {
    pre: true
  }, [_vm._v("data")]), _vm._v(" array to the object attribute corresponding to the node, the corresponding node Node, node assembly itself.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("check-change")]), _vm._v(" "), _c('td', [_vm._v("The node selects the callback when the state changes")]), _vm._v(" "), _c('td', [_vm._v("A total of three parameters, as follows: "), _c('code', {
    pre: true
  }, [_vm._v("data")]), _vm._v(" array to the object attribute corresponding to the node, whether the node itself is checked, whether there is the selected node in the subtree node")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("current-change")]), _vm._v(" "), _c('td', [_vm._v("The event that was triggered when the node was currently selected")]), _vm._v(" "), _c('td', [_vm._v("A total of two parameters, followed by: the current node data, the current node Node object")])])])])
}]
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4d6c6ac3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d6c6ac3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/lib/markdown-compiler.js?raw!./docs/example_en/n3TreeDocs.md
// module id = 891
// module chunks = 1